import React from "react";
import { connect } from "react-redux";
import compose from "ramda/src/compose";
import contains from "ramda/src/contains";
import { translate } from "react-i18next";
import ModalSuccess from "../../ModalSuccess";
import { SIEBEL } from "services/state/billing/constants";
import iconSuccess from "../../../assets/svg/sucesso-da.svg";

const ModalSuccessfulRepair = ({
  t,
  isCurrentStep,
  onReset,
  protocol,
  product,
}) => {
  const isSiebel = () => {
    return product && contains(product.productSystem, [SIEBEL]);
  };

  return (
    <ModalSuccess
      icon={iconSuccess}
      isOpen={isCurrentStep}
      onClose={onReset}
      protocol={protocol}
      msg={isSiebel() ? t("MSG_0285") : t("MSG_0286")}
      msg2={t("MSG_0287")}
      follow
    />
  );
};

const mapStateToProps = ({ repair }) => ({
  protocol: repair.wizard.protocol,
  product: repair.wizard.product,
});

const enhance = compose(translate(), connect(mapStateToProps));

export default enhance(ModalSuccessfulRepair);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalSuccessfulRepair.js